module.exports = __webpack_public_path__ + "static/media/barkbliss-1.06834e5f.jpg";